<template>
    <v-card class="aff-invite-link-container" style="padding: 8px;">
        <div class="aff-invite-link-semi">
            <p class="aff-invite-link-label mb-2"> {{ $t('title.invite_link') }}: </p>
            <v-row class="m-0">
                <p class="aff-invite-link-value">
                    {{ fullRegisterCode }} </p>
                <v-spacer></v-spacer>
                <button class="button-copy" @click="copyText(fullRegisterCode)"> <i
                        class="mdi mdi-content-copy icon"></i>
                    COPY</button>
            </v-row>
        </div>
    </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            staticInviteLink: window.location.hostname + '/register?affcode='
        }
    },
    computed: {
        ...mapGetters("$_modules", {
            userInfo: "getUserInfo",
        }),
        fullRegisterCode() {
            return this.staticInviteLink + this.userInfo.register_code
        }

    },
    methods: {
        async copyText(fullRegisterCode) {
            try {
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    // Using Clipboard API
                    await navigator.clipboard.writeText(fullRegisterCode);
                    this.$toastr.s(this.$t('title.copy'));
                } else {
                    // Fallback to execCommand
                    const textArea = document.createElement('textarea');
                    textArea.value = fullRegisterCode;
                    document.body.appendChild(textArea);
                    textArea.select();
                    document.execCommand('copy');
                    document.body.removeChild(textArea);
                    this.$toastr.s(this.$t('title.copy'));
                }
            } catch (err) {
                console.error('Failed to copy text: ', err);
                this.$toastr.e(this.$t('title.error'));
            }
        }
    }
}
</script>